<template>
  <div>
    <div class="lifestyle-pricelist-ftprice" v-if="!isModalLoading">
      <h1 class="subhead title">FUTURE PRICE</h1>
      <adx-table v-if="items.body.length > 0" :items.sync="items"></adx-table>
      <span v-else class="color-grey">This item doesn't have any future price right now</span>
    </div>
    <a-loading v-else/>
  </div>
</template>

<script>
import api from '@/api'
import { restEdge } from "@/api/edgeUrls"
import moment from 'moment'

import table from '@/components/Table'

import { ALoadingPrimary } from "ui-kit-v1"

export default {
  name: 'adx-lifestyle-placement-ftprice',
  components: {
    'adx-table': table,
    'a-loading': ALoadingPrimary,
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      items: {
        head: [
          {
            title: "START ON",
            type: "text"
          },
          {
            title: "PRICE",
            type: "money"
          },
        ],
        body: []
      },
      isEmpty: false,
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isModalLoading = true
      this.isEmpty = false
      const { data, status } = await api.get(restEdge.lifestylePricelistDetail(this.placementId), { needToken: true, useRestEdge: true })

      if (status === 200) {
        if (data.future_prices.length)
        this.items.body = data.future_prices.map(future => ({
          values: [
            {
              value: moment(future.start).utcOffset(7).format('DD MMM YYYY')
            },
            {
              value: future.public_price
            },
          ]
        }))

        if (!this.items.body.length) this.isEmpty = true
      }

      this.isModalLoading = false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>

</style>
